module.exports = __webpack_public_path__ + "img/ZJ5232.59783bb4.png";